// src/utils/imageUtils.js

const API_BASE_URL = process.env.REACT_APP_API_URL;
// استخراج الرابط الأساسي للـ backend (بدون /api)
const BACKEND_URL = API_BASE_URL.replace('/api', '');

export const getImageUrl = (imagePath) => {
    if (!imagePath) return ''; // أو صورة افتراضية

    // إذا كان الرابط يبدأ بـ http، فهو مطلق بالفعل
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
    }

    // إذا كان المسار يبدأ بـ /، أزله لتجنب التكرار
    const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
    return `${BACKEND_URL}/${cleanPath}`;
};